import React from 'react';
import Nav from '../components/Nav';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './../css/App.css';

class Changelog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
    };
  }

  componentDidMount() {
    fetch('/project-changelog.md')
      .then(response => response.text())
      .then(data => {
        this.setState({ content: data });
      })
      .catch(error => {
        console.error('Error loading markdown:', error);
      });
  }

  render() {return (
    <>
      <Nav activeItem="search"/>
      <div className="hero">
        <p className="asdf">Sürüm Notları</p>
        <p className="asdf2">Güçlenmek için değişmek şart.</p>
      </div>

      <div className="main">
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {this.state.content}
        </ReactMarkdown>
      </div>

      <style>{`
        .main {
          max-width: 650px;
          margin: auto;
          padding: 25px 0px 52px;
        }

        .a {
          color: #00a0d9;
          font-size: 25px;
        }
       
        .hero {
          background: url(/sss-banner.jpg);
          background-size: cover;
          padding: 100px 100px;
          margin-top: 50px;
          text-align: center;
        }
  
        .asdf {
          color: #fff;
          text-align: center;
          margin: 0;
          padding: 0 0 5px;
          font-size: 24px;
          font-weight: bold;
        }

        .asdf2 {
          color: #fff;
          text-align: center;
          margin: 0;
          padding: 0 0 10px;
          font-size: 15px;
        }

        .search-div {
          margin: 0 auto;
          width: max-content;
          display: flex;
        }

        input {
          padding-left: 15px;
          border: 0;
          border: 5px solid #2f2d33;
          border-radius: 20px 0 0 20px;
          width: 300px;
          height: 40px;
          outline: none;
          transition: .2s;
        }
    
        input:focus {
          border: 5px solid #F57029;
        }
      
        input:focus ~ button {
          background: #F57029;
        }

        button {
          height: 40px;
          padding: 1px 25px 1px 15px;
          border: none;
          border-radius: 0 20px 20px 0;
          background: #2f2d33;
          color: #fff;
          outline: none;
          transition: .2s;
        }
        
        button:focus {
          background: #F57029;
        }

        button img {
          width: 25px;
        }

        .error_p {
          text-align: center;
          font-size: 30px;
        }

        @media (max-width: 900px) {
          .hero {
            width: 100%;
            margin: 0;
          }
        }
  
        @media (max-width: 623px) {
         .main {
           padding: 40px 0px 52px;
         }
  
         .hero {
           width: 100%;
           margin: 0;
           padding: 0;
         }

         .asdf {
           display: none;
         }
         
         .asdf2 {
           display: none;
         }

         .search-div {
           margin: 0px auto;
           width: 100%;
           max-width: 100%;
           box-shadow: 0 0 20px 0px rgb(0 0 0 / 30%);
           position: fixed;
           z-index: 10;
         }
         
         #arama {
           width: 80%;
           border-radius: 0;
         }

         #ara-men {
           width: 20%;
           border-radius: 0;
         }
        }
      `}</style>
    </>
    );
}};

export default Changelog;